import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, Field, change } from 'redux-form'
import compose from 'recompose/compose'

import translate from '@/i18n/translate'
import { goToPage as goToPageAction } from '@/state/actions/routes'
import { crudCreate } from '@/state/actions/data'

import { Card } from '@/ui/Card'
import Button from '@/ui/Button/Button'
import { Container, Row, Column, Cell, Flex } from '@/ui/Element'

import { InputField, ImageInput } from '@/ui/Input'
import ImageField from '@/ui/Data/ImageField'

class NewContact extends Component {
  renderImage = props => (
    <ImageInput
      {...props}
      theme={this.props.theme}
      source="image"
      label="Image"
      accept="image/*"
      placeholder={
        <div>
          <span>
            Image, JPG, PNG<br />min. size 360 x 360 px
          </span>
          <p>DROP IMAGE TO UPLOAD</p>
        </div>
      }
    >
      <ImageField source="src" title="title" theme={this.props.theme} />
    </ImageInput>
  )

  saveContact = record => {
    this.props.crudCreate('contacts', record, false, {
      message: `${record.full_name || this.props.initialValues.full_name} created.`,
    })
  }

  goBack = () => {
    this.props.dispatch(this.props.goToPage(this.props.currentRouteData.parent))
  }

  render() {
    const {
      theme,
      handleSubmit,
      submitting,
      // translate,
      // me,
      // data
      //  ...rest
    } = this.props

    return (
      <Container>
        <Column>
          <form className="form" onSubmit={handleSubmit(this.saveContact)}>
            <Cell>
              <Card classes={['v-padding-large', 'colored-card']}>
                <Row gutter="large">
                  <Cell size="33" dir="vertical">
                    <Field
                      name="picture"
                      component={this.renderImage}
                      classes={theme['square-box']}
                      id="picture"
                    />
                  </Cell>
                  <Cell size="66">
                    <Field
                      name="full_name"
                      labelText="Full name:"
                      component={InputField}
                      placeholder="Full name"
                      id="full_name"
                    />
                    <Field
                      name="position"
                      labelText="Position:"
                      component={InputField}
                      placeholder="Contact position"
                      id="position"
                    />
                    <Field
                      name="email"
                      labelText="E-Mail address:"
                      component={InputField}
                      placeholder="you@elovade.com"
                      id="email"
                    />
                    <Field
                      name="phone"
                      labelText="Phone:"
                      component={InputField}
                      placeholder="Phone"
                      id="phone"
                    />
                  </Cell>
                </Row>
              </Card>
            </Cell>
            <Flex horz="right" classes={['top-margin']}>
              <Button
                theme={theme}
                styles="right-margin"
                disabled={submitting}
                onClick={this.goBack}
              >
                Cancel
              </Button>
              <Button
                theme={theme}
                type="submit"
                classes={['secondary']}
                styles="h-padding-large"
                disabled={submitting}
              >
                Save
              </Button>
            </Flex>
          </form>
        </Column>
      </Container>
    )
  }
}

function mapStateToProps(state, props) {
  return {
    data: (state.form.newContact && state.form.newContact.values) || {},
    isLoading: state.rest.loading > 0,
  }
}

const enhance = compose(
  connect(mapStateToProps, {
    goToPage: goToPageAction,
    crudCreate: crudCreate,
    change: change,
  }),
  translate,
  reduxForm({
    form: 'newContact',
    validate: (values, props) => {
      const errors = {}
      const { translate } = props
      ;['full_name', 'position', 'email', 'phone'].forEach(field => {
        if (!values[field]) errors[field] = translate('i18n.validation.required')
      })
      return errors
    },
  }),
)

export default enhance(NewContact)



// WEBPACK FOOTER //
// ./view/Contacts/newContact.js